module.exports = __webpack_public_path__ + "img/sage-pay.2df3db24.png";